
const CTASection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-blue-600 via-blue-700 to-cyan-600 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'url(https://theocean-view.com/wp-content/uploads/2016/03/gary-chair.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 font-serif">
          Ready for Your Keys Adventure?
        </h2>
        <p className="text-xl text-blue-100 mb-10 leading-relaxed">
          Book your stay at The Ocean View Inn & Sports Pub and experience authentic Florida Keys hospitality. Whether you're here for fishing, diving, or just relaxing, we've got everything you need for the perfect vacation.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
          <a
            href="https://hotels.cloudbeds.com/en/reservation/KsGpNF"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center px-8 py-4 bg-white text-blue-600 rounded-lg font-semibold text-lg hover:bg-slate-100 transform hover:scale-105 transition-all duration-300 shadow-xl whitespace-nowrap"
          >
            <i className="ri-calendar-check-line mr-2 text-xl"></i>
            Book Your Room
          </a>
          <a
            href="tel:+13056648052"
            className="inline-flex items-center justify-center px-8 py-4 bg-blue-800 text-white rounded-lg font-semibold text-lg hover:bg-blue-900 transform hover:scale-105 transition-all duration-300 shadow-xl whitespace-nowrap"
          >
            <i className="ri-phone-line mr-2 text-xl"></i>
            Call (305) 664-8052
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-white">
          <div>
            <div className="text-4xl font-bold mb-2">25+</div>
            <div className="text-blue-200">Years of Service</div>
          </div>
          <div>
            <div className="text-4xl font-bold mb-2">1000+</div>
            <div className="text-blue-200">Happy Guests</div>
          </div>
          <div>
            <div className="text-4xl font-bold mb-2">4.5★</div>
            <div className="text-blue-200">Average Rating</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
